import { Component } from 'react'
import { Route, Routes } from 'react-router-dom'
import Article from './Article'
import ActivityMap from './ActivityMap'
import RegionalMap from './RegionalMap'
import ContentGroup from './ContentGroup'
import Front from './Front'
import Pdf from './Pdf'
import { StyleGuide, TermsOfUse, PrivacyPolicy } from '../cdl-react-components/components'
import DefaultRoute from '../Utilities/DefaultRoute'
import Editions from './Editions'
//import FreeResources from './FreeResources'
import LearningLibrary from './LearningLibrary'
import DigestStyleGuideFeatures from '../Utilities/DigestStyleGuideFeatures'

class Pages extends Component {
    render() {
        return (
            <Routes>
                <Route exact path="/" element={<Front />} />
                <Route exact path="/article/:id" element={<Article />} />
                <Route exact path="/activityMap/:id" element={<ActivityMap />} />
                <Route exact path="/regionalMap/:id" element={<RegionalMap />} />
                <Route exact path="/map/:id" element={<RegionalMap />} />
                <Route exact path="/contentGroup/:id" element={<ContentGroup />} />
                <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route exact path="/terms-use" element={<TermsOfUse />} />
                <Route exact path="/pdf" element={<Pdf />} />
                <Route exact path="/style-guide" element={<StyleGuide link='Link' features={<DigestStyleGuideFeatures />} />} />
                <Route exact path="/editions" element={<Editions />} />
                {/*<Route exact path="/free-resources" element={<FreeResources />} />*/}
                <Route exact path="/knowledge-portal" element={<LearningLibrary />} />
                <Route path="*" element={<DefaultRoute/>} />
            </Routes>
        )
    }
}

export default Pages